import { CALL_API, Schemas } from '../../common/middleware/api';

export const CENTER_HOLIDAYS_REQUEST = 'CENTER_HOLIDAYS_REQUEST';
export const CENTER_HOLIDAYS_SUCCESS = 'CENTER_HOLIDAYS_SUCCESS';
export const CENTER_HOLIDAYS_FAILURE = 'CENTER_HOLIDAYS_FAILURE';

export const CENTER_HOLIDAY_FETCH_REQUEST = 'CENTER_HOLIDAY_GET_REQUEST';
export const CENTER_HOLIDAY_FETCH_SUCCESS = 'CENTER_HOLIDAY_GET_SUCCESS';
export const CENTER_HOLIDAY_FETCH_FAILURE = 'CENTER_HOLIDAY_GET_FAILURE';

export const CENTER_HOLIDAY_CREATE_REQUEST = 'CENTER_HOLIDAY_CREATE_REQUEST';
export const CENTER_HOLIDAY_CREATE_SUCCESS = 'CENTER_HOLIDAY_CREATE_SUCCESS';
export const CENTER_HOLIDAY_CREATE_FAILURE = 'CENTER_HOLIDAY_CREATE_FAILURE';

export const CENTER_HOLIDAY_UPDATE_REQUEST = 'CENTER_HOLIDAY_UPDATE_REQUEST';
export const CENTER_HOLIDAY_UPDATE_SUCCESS = 'CENTER_HOLIDAY_UPDATE_SUCCESS';
export const CENTER_HOLIDAY_UPDATE_FAILURE = 'CENTER_HOLIDAY_UPDATE_FAILURE';

export const CENTER_HOLIDAY_DELETE_REQUEST = 'CENTER_HOLIDAY_DELETE_REQUEST';
export const CENTER_HOLIDAY_DELETE_SUCCESS = 'CENTER_HOLIDAY_DELETE_SUCCESS';
export const CENTER_HOLIDAY_DELETE_FAILURE = 'CENTER_HOLIDAY_DELETE_FAILURE';

export const loadHolidaysByCenterAndTerm = ({ centerId, termId, ...options }) => ({
	[CALL_API]: {
		types: [CENTER_HOLIDAYS_REQUEST, CENTER_HOLIDAYS_SUCCESS, CENTER_HOLIDAYS_FAILURE],
		endpoint: 'api/centerHolidays',
		request: { centerId, termId, ...options },
		schema: Schemas.CENTER_HOLIDAYS_ARRAY
	},
	centerId,
	termId
});

export const fetchCenterHoliday = (id) => ({
	[CALL_API]: {
		types: [CENTER_HOLIDAY_FETCH_REQUEST, CENTER_HOLIDAY_FETCH_SUCCESS, CENTER_HOLIDAY_FETCH_FAILURE],
		endpoint: `api/centerHolidays/${id}`,
		schema: Schemas.CENTER_HOLIDAY
	}
});

export const createCenterHoliday = (centerHoliday, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CENTER_HOLIDAY_CREATE_REQUEST, CENTER_HOLIDAY_CREATE_SUCCESS, CENTER_HOLIDAY_CREATE_FAILURE],
		endpoint: 'api/centerHolidays',
		method: 'POST',
		request: centerHoliday,
		schema: Schemas.CENTER_HOLIDAY,
		form: 'centerHoliday',
		onSuccessEvent
	}
});

export const updateCenterHoliday = (id, centerHoliday, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CENTER_HOLIDAY_UPDATE_REQUEST, CENTER_HOLIDAY_UPDATE_SUCCESS, CENTER_HOLIDAY_UPDATE_FAILURE],
		endpoint: `api/centerHolidays/${id}`,
		method: 'PUT',
		request: centerHoliday,
		schema: Schemas.CENTER_HOLIDAY,
		form: 'centerHoliday',
		onSuccessEvent
	}
});

export const deleteCenterHoliday = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CENTER_HOLIDAY_DELETE_REQUEST, CENTER_HOLIDAY_DELETE_SUCCESS, CENTER_HOLIDAY_DELETE_FAILURE],
		endpoint: `api/centerHolidays/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});